export const CONTACT_EMAIL = "contact@example.com";
export const CONTACT_PHONE = "+48 507 705 197";
export const LINKEDIN_URL =
  "https://www.linkedin.com/in/krzysztof-pioro-3aaa7548/";
export const XING_URL = "https://www.xing.com/profile/Krzysztof_Pioro";
